import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Badge, LockIcon } from 'stylist'

export default class AdvancedSearchLink extends Component {
  static propTypes = {
    arrow: PropTypes.string,
    text: PropTypes.string,
    textClass: PropTypes.string
  }

  static defaultProps = {
    arrow: '',
    text: 'Advanced Search',
    textClass: ''
  }

  orderElements = () => {
    const { arrow, text, textClass } = this.props

    switch (arrow) {
      case 'right':
        return (
          <div>
            <a className={textClass}>{text}</a>
            <i className="im-icon-chevron-right" />
          </div>
        )
      case 'left':
        return (
          <div>
            <i className="im-icon-chevron-left" />
            <a className={textClass}>{text}</a>
          </div>
        )
      default:
        return (
          <div>
            <a className={textClass}>{text}</a>
          </div>
        )
    }
  }

  render() {
    return <Fragment>{this.orderElements()}</Fragment>
  }
}

export class LockBadge extends Component {
  static propTypes = {
    kind: PropTypes.string,
    text: PropTypes.string
  }

  static defaultProps = {
    kind: 'pro',
    text: ''
  }

  render() {
    const { kind, text } = this.props

    return (
      <div style={{ width: '200px' }}>
        <a className="link-with-badge">
          <span>{I18n.t(text)}</span>
          <Badge kind={kind} className="right">
            <LockIcon size="s" />
          </Badge>
        </a>
      </div>
    )
  }
}

export class CollectionStatusLink extends Component {
  static propTypes = {
    textClass: PropTypes.string
  }

  static defaultProps = {
    textClass: 'search-header-tooltip-link wide-collection-status-link'
  }

  render() {
    const { textClass } = this.props

    return (
      <a className={textClass}>
        <span>Collection Status</span>
        <Badge kind="pro" className="right">
          <LockIcon size="s" />
        </Badge>
      </a>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/TooltipBaseLink.js